import { Translate } from "../../../../components/Generic/UploadCSVFile/types";

export interface InvoicesTemplateCSV {
  shipment: string;
  poNumber: string;
  partNumber: string;
  origin: string;
  country: string;
  destination: string;
  etd: string;
  eta: string;
  mode: string;
  container: string;
  supplierName: string;
  houseBill: string;
  masterBill: string;
  containers: string;
  weight: string;
  teu: string;
  cbm: string;
  cartons: string;
  hblMode: string;
  chargeCode: string;
  description: string;
  overseasAmount: string;
  exchangeRateCurrency: string;
  exchangeRate: string;
  invoicedLocalAmount: string;
  gstAmount: string;
  invoiceNumber: string;
  invoiceDate: string;
  invoiceDueDate: string;
  delivered: string;
  autoRate: string;
  cottonOnAdultsApportionment: string;
  cottonOnAdultsLocalAmount: string;
  ceresLifeApportionment: string;
  ceresLifeLocalAmount: string;
  bodyApportionment: string;
  bodyLocalAmount: string;
  factorieApportionment: string;
  factorieLocalAmount: string;
  kidsApportionment: string;
  kidsLocalAmount: string;
  rubiApportionment: string;
  rubiLocalAmount: string;
  foundationApportionment: string;
  foundationLocalAmount: string;
  typoApportionment: string;
  typoLocalAmount: string;
  gamedayApportionment: string;
  gamedayLocalAmount: string;
  supreApportionment: string;
  supreLocalAmount: string;
  fixturesApportionment: string;
  fixturesLocalAmount: string;
  consumablesApportionment: string;
  consumablesLocalAmount: string;
  otherApportionment: string;
  otherLocalAmount: string;
}

export const getInvoicesTemplateColumnName = (translate: Translate) => {
  return {
    partNumber: translate("partNumber"),
    country: translate("country"),
    etd: translate("etd"),
    eta: translate("eta"),
    container: translate("container"),
    houseBill: translate("House Bill"),
    masterBill: translate("Master Bill"),
    containers: translate("containers"),
    weight: translate(" weight"),
    teu: translate("teu"),
    cbm: translate("cbm"),
    cartons: translate("cartons"),
    hblMode: translate("hblCountMode"),
    chargeCode: translate("chargeCode"),
    description: translate("description"),
    overseasAmount: translate("overseasAmount"),
    exchangeRateCurrency: translate("exchangeRateCurrency"),
    exchangeRate: translate("exchangeRate"),
    invoicedLocalAmount: translate("invoicedLocalAmount"),
    gstAmount: translate("gstAmount"),
    invoiceNumber: translate("invoiceNumber"),
    invoiceDate: translate("invoiceDate"),
    invoiceDueDate: translate("invoiceDueDate"),
    delivered: translate("delivered"),
    autoRate: translate("autoRate"),
    cottonOnAdultsApportionment: translate("cottonOnAdultsApportionment"),
    cottonOnAdultsLocalAmount: translate("cottonOnAdultsLocalAmount"),
    ceresLifeApportionment: translate("ceresLifeApportionment"),
    cereLifeLocalAmount: translate("cereLifeLocalAmount"),
    bodyApportionment: translate("bodyApportionment"),
    bodyLocalAmount: translate("bodyLocalAmount"),
    factorieApportionment: translate("factorieApportionment"),
    factorieLocalAmount: translate("factorieLocalAmount"),
    kidsApportionment: translate("kidsApportionment"),
    kidsLocalAmount: translate("kidsLocalAmount"),
    rubiApportionment: translate("v"),
    rubiLocalAmount: translate("rubiLocalAmount"),
    foundationApportionment: translate("foundationApportionment"),
    foundationLocalAmount: translate("foundationLocalAmount"),
    typoApportionment: translate("typoApportionment"),
    typoLocalAmount: translate("typoLocalAmount"),
    gamedayApportionment: translate("gamedayApportionment"),
    gamedayLocalAmount: translate("gamedayLocalAmount"),
    supreApportionment: translate("supreApportionment"),
    supreLocalAmount: translate("supreLocalAmount"),
    fixturesApportionment: translate("fixturesApportionment"),
    fixturesLocalAmount: translate("fixturesLocalAmount"),
    consumablesApportionment: translate("consumablesApportionment"),
    consumablesLocalAmount: translate("consumablesLocalAmount"),
    otherApportionment: translate("otherApportionment"),
    otherLocalAmount: translate("otherLocalAmount"),
    shipment: translate("shipment"),
    poNumber: translate("poNumber"),
    supplierName: translate("supplierName"),
    consol: translate("consol"),
    mode: translate("mode"),
    origin: translate("origin"),
    destination: translate("destination"),
  };
};

export interface UploadCsvError {
  type: "shipment" | "order" | "product";
  column: string;
  translate: string;
}
